<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters v-for="(item, index) in measures.items" :key="index">
                    <v-col cols="12" class="d-flex subtitle-1 font-weight-black align-center justify-left grey lighten-4" v-if="item.isSection">
                        <div class="caption">{{item.referral}}.</div><div class="pl-2 font-italic">{{item.name}}</div>
                    </v-col>
                    <v-col cols="12">
                        <div class="d-flex flex-column my-2">
                            <div :class="customText('d-flex font-italic',item)" v-if="!item.isSection">
                            <span class="pr-1" v-if="item.blocking">*</span><span class="pr-1" v-else>&nbsp;</span>{{item.name}}
                            </div>
                            <v-radio-group class="ma-0 pt-2 pl-4 py-1" hide-details v-if="item.hasRadioButtons" v-model="item.result" @change="updateResult" row :disabled="preview">
                                <v-radio label="conforme" value="success" hide-details></v-radio>
                                <v-radio label="non conforme" value="fail" hide-details></v-radio>
                                <v-radio v-if="item.value_na" label="N.A." value="na" hide-details></v-radio>
                            </v-radio-group>
                            <v-text-field dense outlined
                                v-if="item.hasRadioButtons"
                                class="pa-0 pl-4 ma-0"
                                :readonly="preview" :clearable="!preview"
                                label="note"
                                v-model="item.notes"
                                hide-details
                            ></v-text-field>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <span>*<span class="caption pl-1">
            il mancato superamento di una delle 
            prove contrassegnate dall'asterisco porta alla non identificabilità dello strumento 
            e ad un conseguente esito negativo della verifica</span>
        </span>
    </LayoutBlock>
</template>isSection
<script>
import {vcheck_tile} from '../../../utils/itemBlockSchema';
// import _ from 'lodash'
import LayoutBlock from "../../../components/utils/LayoutBlock"

export default {
    components: {LayoutBlock},
    props: ['data', 'preview'],
    data(){
        return{
            pagination: {'rowsPerPage': -1},
            conf: null,
            measures: null,
            tutorial_dialog: {
                dialog: false,
                message: this.data.block.conf.tutorial_text
            },
            result: false
        }
    },
    created(){
        this.debouncedSave = _.debounce(function(){
            this.saveMeasures()
        },1000)
    },
    watch:{
        measures:{
            deep:true,
            handler(){
                if(!this.preview){
                    this.debouncedSave();
                }
            }
        }
    },
    computed: {
        headers(){
            let data = []
            for (let item of this.conf.headers){
                let obj = {
                    text: item,
                    value: item,
                    align: 'left',
                    sortable: false
                }
                data.push(obj)
            }
            return data
        }
    },
    methods: {
        updateResult() {
            // console.log('RESULT 1', this.result, this.measures.items)
            this.measures.result = this.measures.items.reduce(function(result, item) {
                let res = 'done'
                switch (item.result) {
                    case 'fail':
                    case 'na':
                        if (item.blocking) {
                            res = 'failed'
                        } else {
                            res = result
                        }
                        break
                    case 'success':
                        res = result
                        break
                }
                return res
            }, 'done')
            // console.log('RESULT 2', this.measures.result)
        },
        buildMeasures() {
            this.measures = {
                items: [],
                test: 'na',
                result: 'uncomplete'
            }
            for (let item of this.conf.newList){
                let sect = vcheck_tile({
                    referral: item.referral,
                    name: item.title,
                    isSection: true,
                    sectionLength: item.innerItems.length + 1,
                    hasRadioButtons: false
                })
                this.measures.items.push(sect)
                for (let row of item.innerItems){
                    // console.log("$$ debug", row)
                    let elem = vcheck_tile({
                        referral: item.referral,
                        name: row.element,
                        isSection: false,
                        sectionLength: 0,
                        hasRadioButtons: true,
                        blocking: row.blocking || false,
                        value_na: row.value_na || false
                    })
                    this.measures.items.push(elem)
                }
            }
            console.log("DEBUG items", this.measures)
        },
        saveMeasures() {
            console.log('RESULT', this.result)
            this.$parent.$emit('updateMeasure', {b_index: this.data.b_index, measures: this.measures, p_idx: this.data.p_idx, p_id: this.data.p_id})
        },
        handleCloseDialog(){
            this.tutorial_dialog.dialog = false;
        },
        customText(baseClass, item){
            if(item.blocking && (item.result == "fail" || item.result == "na")){
                return baseClass + " red--text"
            } else {
                return baseClass
            }
        }
    },
    beforeMount(){
        console.log("DEBUG visualcheck props", this.data)
        this.conf = this.data.block.conf
        if(this.data.block.measures != undefined && this.data.block.measures != null){
            this.measures = this.data.block.measures
        } else {
            this.buildMeasures()
        }
        this.updateResult()
    }
}
</script>
